/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocationDto } from '../../models/location-dto';
import { LocationShowResponse } from '../../models/location-show-response';

export interface PostLocationCreate$Params {
      body: LocationDto
}

export function postLocationCreate(http: HttpClient, rootUrl: string, params: PostLocationCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<LocationShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postLocationCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LocationShowResponse>;
    })
  );
}

postLocationCreate.PATH = '/v1/location';
